import { ar, es, fr, ka } from 'date-fns/locale';
import { useTranslation } from 'next-i18next';
import { ReactElement } from 'react';
import * as React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { ReactDatePickerProps } from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.min.css';

import { InputField } from '@/shared/components/atoms/InputField';
import { IInputFieldProps } from '@/shared/components/atoms/InputField/IInputField.d';

import Calender from '~/images/shared/calender.svg';

registerLocale('ar', ar);
registerLocale('es', es);
registerLocale('fr', fr);
registerLocale('ka', ka);

interface ILocalizedDatePickerProps {
  datePickerProps?: ReactDatePickerProps;
  defaultDate?: Date;
  inputProps?: IInputFieldProps;
  className?: string;
}
/**
 *
 * @defaultDate  {Date} : default selected day if not passed that will be current day
 * @onChange   : {fun(Date)} : when change selected day will call this fun with the new selected day
 * @returns
 */
export default function LocalizedDatePicker({
  datePickerProps,
  inputProps,
  className,
}: ILocalizedDatePickerProps): ReactElement {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  // return date picker without days
  return (
    <div className={className}>
      <DatePicker
        {...datePickerProps}
        locale={language}
        placeholderText={datePickerProps?.placeholderText ?? t('select-date')}
        dateFormat={datePickerProps?.dateFormat || 'dd/MM/yyyy'}
        onChange={(date, e) => {
          datePickerProps?.onChange(date, e);
        }}
        customInput={
          datePickerProps?.customInput ?? (
            <InputField
              {...inputProps}
              className='text-primary-default'
              suffix={<Calender />}
            />
          )
        }
      />
    </div>
  );
}
